<template>
  <TransitionRoot
    as="div"
    :show="open"
    class="fixed inset-0 z-[10001]"
  >
    <Dialog
      as="div"
      class="relative z-[10001]"
      :open="open"
      @close="emit('close')"
    >
      <TransitionChild
        as="div"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      />

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex h-full items-stretch justify-center p-0">
          <TransitionChild
            as="div"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
            class="w-full h-full"
          >
            <DialogPanel
              class="relative flex flex-col transform overflow-hidden bg-white dark:bg-gray-900 text-left shadow-xl transition-all w-full h-full rounded-none border-0"
            >
              <slot />
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue'

interface Props {
  open: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  close: []
}>()
</script>
